import React, {useContext, useEffect, useState} from 'react';
import {PAContext} from "../../../Services/PAContext";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';

import {
    Avatar, AvatarGroup,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    CardMedia,
    Menu,
    MenuItem,
    Tooltip,
    Chip, Divider
} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import ListItemIcon from "@mui/material/ListItemIcon";
import {
    Timeline,
    TimelineContent,
    TimelineItem,
    timelineItemClasses, TimelineOppositeContent, timelineOppositeContentClasses
} from "@mui/lab";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {capitalizeFirstLetter, formatName, formatTime, stringAvatar, stringToColor} from "../../Helpers/TextStyling";

import Rating from "@mui/material/Rating";

import MealDialogEditAttendees from "./MealDialogEditAttendees";
import MealDialogEditDetails from "./MealDialogEditDetails";
import MealDialogEditCosts from "./MealDialogEditCosts";
import MealDialogEditDates from "./MealDialogEditDates";
import MealDialogEditPhotos from "./MealDialogEditPhotos";
import MealDialogEditLocation from "./MealDialogEditLocation";
import './meals.css';
import {getAllContactsFromDatabase} from "../../Restricted/Contacts/BrowserDatabaseFunctions";

dayjs.extend(customParseFormat);

const MEAL_STATUSES = [
    { value: 0, label: "💡 Idea / Unplanned", color: "#64748b", bg: "rgba(100, 116, 139, 0.1)", icon: "icon-info" },
    { value: 1, label: "⏳ Looking for Table", color: "#f59e0b", bg: "rgba(245, 158, 11, 0.1)", icon: "icon-history" },
    { value: 2, label: "📞 Reservation Requested", color: "#3b82f6", bg: "rgba(59, 130, 246, 0.1)", icon: "icon-phone" },
    { value: 3, label: "✅ Confirmed", color: "#10b981", bg: "rgba(16, 185, 129, 0.1)", icon: "icon-checkmark-circle" },
    { value: 4, label: "🍽️ Seated / Active", color: "#8b5cf6", bg: "rgba(139, 92, 246, 0.1)", icon: "icon-table" },
    { value: 5, label: "🏁 Completed & Settled", color: "#ec4899", bg: "rgba(236, 72, 153, 0.1)", icon: "icon-flag" },
    { value: 6, label: "⚠️ Delayed / Running Late", color: "#d97706", bg: "rgba(217, 119, 6, 0.1)", icon: "icon-warning" },
    { value: 7, label: "❌ Cancelled by Us", color: "#ef4444", bg: "rgba(239, 68, 68, 0.1)", icon: "icon-cancel-circle" },
    { value: 8, label: "🚫 Cancelled by Venue", color: "#b91c1c", bg: "rgba(185, 28, 28, 0.1)", icon: "icon-blocked" }
];

function MealCard(props){

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, sendSocketMessage } = useContext(PAContext);
    const { Account, SampleAttendees, authenticated } = dataArray;

    const [dbContacts, setDbContacts] = useState([]);
    useEffect(() => {
        if (!authenticated) {
            setDbContacts([]);
            return;
        }

        let cancelled = false;

        getAllContactsFromDatabase()
            .then(contacts => {
                if (cancelled) return;
                setDbContacts(Array.isArray(contacts) ? contacts : []);
            })
            .catch(err => {
                console.error('Failed to load Contacts from browser DB:', err);
                if (!cancelled) {
                    setDbContacts([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [authenticated]);

    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( authenticated
        ? dbContacts
        : SampleAttendees);

    useEffect(() => {
        setAttendeesReferenceArray(
            authenticated
                ? dbContacts
                : SampleAttendees
        );
    }, [authenticated, dbContacts, SampleAttendees]);

    const [eventMeal, setEventMeal] = useState(props.meal);
    function deepEqual(a, b) {
        if (a === b) return true;
        if (Number.isNaN(a) && Number.isNaN(b)) return true;
        if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
        if (!a || !b || typeof a !== "object" || typeof b !== "object") return false;

        const aIsArr = Array.isArray(a), bIsArr = Array.isArray(b);
        if (aIsArr !== bIsArr) return false;

        if (aIsArr) {
            if (a.length !== b.length) return false;
            for (let i = 0; i < a.length; i++) if (!deepEqual(a[i], b[i])) return false;
            return true;
        }

        const aKeys = Object.keys(a), bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const k of aKeys) if (!Object.prototype.hasOwnProperty.call(b, k)) return false;
        for (const k of aKeys) if (!deepEqual(a[k], b[k])) return false;
        return true;
    }

    function deepMergePreserveExtras(base, patch) {
        if (patch === null) return null;
        const baseIsObj = base && typeof base === "object";
        const patchIsObj = patch && typeof patch === "object";
        if (!baseIsObj || !patchIsObj) return patch;

        if (Array.isArray(base) || Array.isArray(patch)) {
            return Array.isArray(patch) ? patch.slice() : patch;
        }

        const out = { ...base };
        for (const key of Object.keys(patch)) {
            const merged = deepMergePreserveExtras(base[key], patch[key]);
            if (merged === null) {
                if (key in out) delete out[key];
            } else {
                out[key] = merged;
            }
        }
        return out;
    }
    useEffect(() => {
        const merged = deepMergePreserveExtras(eventMeal, props.meal);
        if (!deepEqual(merged, eventMeal)) {
            setEventMeal(merged);
        }
    }, [props.meal]);

    const [eventMealPhotos, setEventMealPhotos] = useState([]);

    const photos = eventMeal.attendee_photos?.length > 0
        ? eventMeal.attendee_photos
        : eventMeal.photos || [];

    const [visiblePhotos, setVisiblePhotos] = useState(() => photos.map(() => true));

    useEffect(() => {
        setVisiblePhotos(photos.map(() => true));
    }, [photos]);



    const [anchorMealListItemMenu, setAnchorMealListItemMenu] = useState(null);
    const handleMealListItemMenuOpenMenu = (event) => {
        setAnchorMealListItemMenu(event.currentTarget);
    };
    const handleMealListItemMenuClose = () => {
        setAnchorMealListItemMenu(null);
    };

    const [isMealsDialogEditAttendeesOpen, setMealsDialogEditAttendeesOpen] = useState(false);
    const [isMealsDialogEditCostsOpen, setMealsDialogEditCostsOpen] = useState(false);
    const [isMealsDialogEditPhotosOpen, setMealsDialogEditPhotosOpen] = useState(false);
    const [isMealsDialogEditDatesOpen, setMealsDialogEditDatesOpen] = useState(false);
    const [isMealsDialogEditLocationOpen, setMealsDialogEditLocationOpen] = useState(false);
    const [isMealsDialogEditDetailsOpen, setMealsDialogEditDetailsOpen] = useState(false);

    useEffect(() => {
        const currentPlaceId = eventMeal['location']?.google_place_id;

        if (currentPlaceId) {
            setEventMealPhotos([]);
            fetchPlacePhotos(currentPlaceId);
        } else {
            setEventMealPhotos([]);
        }
    }, [eventMeal['location']?.google_place_id]);

    const fetchPlacePhotos = async (placeId) => {
        const { Place } = await window.google.maps.importLibrary("places");
        const place = new Place({ id: placeId });
        try {
            await place.fetchFields({ fields: ['photos'] });
            if (place.photos && place.photos.length > 0) {
                const urls = place.photos.map(p => p.getURI({ maxWidth: 150, maxHeight: 150 }));
                setEventMealPhotos(urls);
            }
        } catch (error) {
            console.error("Error fetching place photos:", error);
        }
    };

    const handleMenuItemClick = (_item_name) => {
        setAnchorMealListItemMenu(null);

        if (_item_name === 'Delete') {
            props.onDeleteMeal();
        }

        switch (_item_name) {
            case "Attendees":
                setMealsDialogEditAttendeesOpen(!isMealsDialogEditAttendeesOpen);
                break;
            case "Costs":
                setMealsDialogEditCostsOpen(!isMealsDialogEditCostsOpen);
                break;
            case "Photos":
                setMealsDialogEditPhotosOpen(!isMealsDialogEditPhotosOpen);
                break;
            case "Dates":
                setMealsDialogEditDatesOpen(!isMealsDialogEditDatesOpen);
                break;
            case "Location":
                setMealsDialogEditLocationOpen(!isMealsDialogEditLocationOpen);
                break;
            case "Details":
                setMealsDialogEditDetailsOpen(!isMealsDialogEditDetailsOpen);
                break;
            default:
                break;
        }
    };

    // Robust parsing for status configs supporting numbers and strings
    const getStatusStyles = (status) => {
        if (status === undefined || status === null) return null;

        // Handle database numbers configuration natively
        if (typeof status === 'number') {
            const found = MEAL_STATUSES.find(s => s.value === status);
            if (found) {
                return {
                    label: found.label,
                    color: "default",
                    icon: found.icon,
                    bg: found.bg,
                    textColor: found.color
                };
            }
        }

        // Backwards compatibility legacy string format parsing
        const normalized = String(status).toLowerCase();
        switch (normalized) {
            case 'confirmed':
                return { label: '✅ Confirmed', icon: 'icon-checkmark-circle', bg: 'rgba(16, 185, 129, 0.1)', textColor: '#10b981' };
            case 'tentative':
            case 'pending':
                return { label: '⏳ Tentative', icon: 'icon-history', bg: 'rgba(245, 158, 11, 0.1)', textColor: '#f59e0b' };
            case 'cancelled':
            case 'canceled':
                return { label: '❌ Cancelled', icon: 'icon-cancel-circle', bg: 'rgba(239, 68, 68, 0.1)', textColor: '#ef4444' };
            default:
                return { label: capitalizeFirstLetter(normalized), icon: 'icon-info', bg: 'rgba(241, 245, 249, 0.6)', textColor: '#64748b' };
        }
    };

    const statusConfig = getStatusStyles(eventMeal.status);

    const handleSaveMealUpdate = (updatedMeal) => {
        console.log("handleSaveMealUpdate : ", updatedMeal);

        // 1. Update local state
        setEventMeal(updatedMeal);

        // 2. Check for missing global attendees
        const globalAttendees = usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees;
        const newMealAttendees = updatedMeal.attendees || [];

        const attendeesToAdd = newMealAttendees
            .filter(newAtt => !globalAttendees.some(existing => existing.id === newAtt.id))
            .map(newAtt => attendeesReferenceArray.find(ref => ref.id === newAtt.id))
            .filter(Boolean);

        // 3. Update Zustand Global Store ONCE upon user save
        set_PA_GlobalObject((prev) => ({
            Planning: {
                ...prev.Planning,
                attendees: attendeesToAdd.length > 0
                    ? [...prev.Planning.attendees, ...attendeesToAdd]
                    : prev.Planning.attendees,
                meals: prev.Planning.meals.map((m) =>
                    m.id === updatedMeal.id ? { ...m, ...updatedMeal } : m
                ),
            },
        }));

        // 4. Emit Web Socket message ONCE upon user save
        if (PA_GlobalObject.Planning?.status !== 10) {
            sendSocketMessage({
                action: "E_updateEventMeal_v2",
                event_id: PA_GlobalObject.Planning.id,
                meal: updatedMeal,
            });
        }
    };


    return (
        <div>
            <Card
                sx={{
                    borderRadius: '16px',
                    background: 'rgba(255, 255, 255, 0.4)',
                    backdropFilter: 'blur(12px)',
                    WebkitBackdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.08)',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    '&:hover': {
                        boxShadow: '0 8px 32px 0 rgba(240, 150, 55, 0.15)',
                        borderColor: 'rgba(240, 150, 55, 0.4)'
                    }
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                    <Box sx={{ flexGrow: 1, position: 'relative' }}>

                        {/* 📸 IMAGE AREA SECTION */}
                        {(
                            eventMeal['attendee_photos'] && eventMeal['attendee_photos'].length > 0 ? (
                                <Box sx={{
                                    p: '12px 12px 0 12px',
                                    '& .horizontal-scroll-container': {
                                        display: 'flex', gap: '8px', overflowX: 'auto', pb: '4px',
                                        '&::-webkit-scrollbar': { height: '4px' },
                                        '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: '4px' }
                                    }
                                }}>
                                    <div className="meals-suggestions-add-list-item-photos">
                                        <div className="horizontal-scroll-container">
                                            {
                                                (eventMeal['attendee_photos']).map((photo, index) => {
                                                    const imageSrc = PA_GlobalObject.Planning.photos.find(_p => _p.id === photo.photo_id)?.thumbnail_data || PA_GlobalObject.Planning.photos.find(_p => _p.id === photo.photo_id)?.full_data;

                                                    return visiblePhotos[index] ? (
                                                        <CardMedia
                                                            key={index}
                                                            component="img"
                                                            alt={`Photo ${index + 1}`}
                                                            image={imageSrc}
                                                            sx={{ width: 120, height: 120, borderRadius: '8px', objectFit: 'cover' }}
                                                            onError={() =>
                                                                setVisiblePhotos(prev => {
                                                                    const updated = [...prev];
                                                                    updated[index] = false;
                                                                    return updated;
                                                                })
                                                            }
                                                        />
                                                    ) : null;
                                                })
                                            }
                                        </div>
                                    </div>
                                </Box>
                            ) : eventMealPhotos && eventMealPhotos.length > 0 ? (
                                <Box sx={{
                                    p: '12px 12px 0 12px',
                                    '& .horizontal-scroll-container': {
                                        display: 'flex', gap: '8px', overflowX: 'auto', pb: '4px',
                                        '&::-webkit-scrollbar': { height: '4px' },
                                        '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: '4px' }
                                    }
                                }}>
                                    <div className="meals-suggestions-add-list-item-photos">
                                        <div className="horizontal-scroll-container">
                                            {eventMealPhotos.map((url, index) => (
                                                <CardMedia
                                                    key={index}
                                                    component="img"
                                                    alt={`Photo ${index + 1}`}
                                                    image={url}
                                                    sx={{ width: 120, height: 120, borderRadius: '8px', objectFit: 'cover' }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </Box>
                            ) : null
                        )}

                        {/* 🏷️ HEADER CONTAINER */}
                        <CardHeader
                            title={(() => {
                                const { time_table } = eventMeal;
                                if (!time_table) return '';
                                if (!time_table?.dates?.length) {
                                    if (time_table.days && time_table.days.length > 0) {
                                        const _entry = time_table.days[0];
                                        const key = Object.keys(_entry).find(k => k.startsWith("day "));
                                        const dayName = _entry[key];
                                        if (key && dayName) {
                                            const shortDay = dayName.slice(0, 3);
                                            return `${shortDay}, ${capitalizeFirstLetter(key)}`;
                                        }
                                    }
                                    return '';
                                }
                                const firstDate = time_table.dates[0]?.date || null;
                                const lastDate = time_table.dates[time_table.dates.length - 1]?.date || null;
                                const startDateObj = firstDate ? dayjs(firstDate, "YYYY-MM-DD") : null;
                                const endDateObj = lastDate ? dayjs(lastDate, "YYYY-MM-DD") : null;

                                if (!startDateObj?.isValid() || !endDateObj?.isValid()) return '';

                                const formattedStartDate = startDateObj.format('ddd, MMM D');
                                const formattedEndDate = !startDateObj.isSame(endDateObj, 'day')
                                    ? ` - ${endDateObj.format('ddd, MMM D')}`
                                    : '';
                                return `${formattedStartDate}${formattedEndDate}`;
                            })()}
                            action={(() => {
                                const _att = attendeesReferenceArray.find(_att => _att.id === Account?.id);
                                const userAttendees = Array.isArray(eventMeal?.attendees) ? eventMeal.attendees : [];
                                const canShowMenu = _att?.role === "planner" || _att?.role === "master_admin" || _att?.role === "admin" || userAttendees.some(_a => _a.id === Account?.id);

                                if (!canShowMenu) return null;

                                return (
                                    <IconButton onClick={handleMealListItemMenuOpenMenu} sx={{ color: 'text.secondary' }}>
                                        <i className="icon-menu2" style={{ fontSize: '16px' }} />
                                    </IconButton>
                                );
                            })()}
                            sx={{
                                p: '16px 16px 8px 16px',
                                "& .MuiCardHeader-title": {
                                    fontSize: "1.05rem",
                                    fontWeight: 700,
                                    color: '#2c3e50'
                                },
                            }}
                        />

                        {/* ⏱️ SUB-HEADER TYPE TRACKER & STATUS BADGE */}
                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ px: '16px', mb: 1, gap: 1 }}>
                            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, bgcolor: 'rgba(0,0,0,0.04)', px: 1, py: 0.25, borderRadius: '4px' }}>
                                {eventMeal['name'] ? eventMeal['name'].toUpperCase() : 'MEAL'}
                            </Typography>
                            {statusConfig && (
                                <Chip
                                    label={statusConfig.label}
                                    size="small"
                                    sx={{
                                        fontWeight: 800,
                                        fontSize: '11px',
                                        borderRadius: '8px',
                                        backgroundColor: statusConfig.bg,
                                        color: statusConfig.textColor,
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.02)',
                                        border: `1px solid ${statusConfig.textColor}20`
                                    }}
                                />
                            )}
                        </Box>

                        {/* 🗺️ TIMELINE & CONTENT */}
                        <CardContent sx={{ pt: 0, pb: '60px !important' }}>
                            <Timeline
                                sx={{
                                    [`& .${timelineOppositeContentClasses.root}`]: { flex: 0.3, textAlign: 'left', px: 0 },
                                    [`& .${timelineItemClasses.root}:before`]: { flex: 0, padding: 0 },
                                    padding: 0, mb: 2
                                }}
                            >
                                <TimelineItem sx={{ minHeight: 0 }}>
                                    <TimelineOppositeContent>
                                        {eventMeal.time_table?.dates?.length > 0 ? (
                                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                {eventMeal.time_table.dates[0].begin_time && (
                                                    <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.primary' }}>{formatTime(eventMeal.time_table.dates[0].begin_time)}</Typography>
                                                )}
                                                {eventMeal.time_table.dates[eventMeal.time_table.dates.length - 1].end_time && (
                                                    <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary' }}>{formatTime(eventMeal.time_table.dates[eventMeal.time_table.dates.length - 1].end_time)}</Typography>
                                                )}
                                            </Box>
                                        ) : eventMeal.time_table?.days?.length > 0 ? (
                                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                {eventMeal.time_table.days[0].begin_time && (
                                                    <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.primary' }}>{formatTime(eventMeal.time_table.days[0].begin_time)}</Typography>
                                                )}
                                                {eventMeal.time_table.days[eventMeal.time_table.days.length - 1].end_time && (
                                                    <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary' }}>{formatTime(eventMeal.time_table.days[eventMeal.time_table.days.length - 1].end_time)}</Typography>
                                                )}
                                            </Box>
                                        ) : null}
                                    </TimelineOppositeContent>

                                    <TimelineContent sx={{ borderLeft: '2px solid #f09637', pl: 2, pr: 0, py: 0, ml: 1.5 }}>
                                        <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: '#2c3e50', mb: 0.5 }} variant="body2">
                                            {eventMeal['location']?.name || 'Unassigned Restaurant'}
                                        </Typography>

                                        {eventMeal['location'] && (
                                            <Box
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    const loc = eventMeal['location'];
                                                    // Build search string using restaurant name + full address details for high accuracy
                                                    const searchQuery = [
                                                        loc.name,
                                                        loc.address,
                                                        loc.city,
                                                        loc.state,
                                                        loc.zip
                                                    ].filter(Boolean).join(' ');

                                                    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(searchQuery)}`;
                                                    window.open(mapsUrl, '_blank', 'noopener,noreferrer');
                                                }}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 0.25,
                                                    cursor: 'pointer',
                                                    width: 'fit-content',
                                                    '&:hover .map-link': {
                                                        textDecoration: 'underline',
                                                        color: '#1e293b'
                                                    }
                                                }}
                                            >
                                                {eventMeal['location']?.address && (
                                                    <Typography className="map-link" sx={{ fontSize: '12px', color: 'text.secondary' }}>
                                                        {eventMeal['location'].address}
                                                    </Typography>
                                                )}

                                                {(eventMeal['location']?.city || eventMeal['location']?.state || eventMeal['location']?.zip) && (
                                                    <Typography className="map-link" sx={{ fontSize: '12px', color: 'text.secondary' }}>
                                                        {[
                                                            eventMeal['location']?.city,
                                                            eventMeal['location']?.state,
                                                            eventMeal['location']?.zip
                                                        ].filter(Boolean).join(' ')}
                                                    </Typography>
                                                )}
                                            </Box>
                                        )}
                                    </TimelineContent>
                                </TimelineItem>
                            </Timeline>

                            {/* 🌐 QUICK LINKS SECTION */}
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2, mt: 1, pl: '4px' }}>
                                {eventMeal['Place']?.website && (
                                    <Box onClick={() => window.open(eventMeal['Place'].website, '_blank')} sx={{ display: 'flex', alignItems: 'center', fontSize: '13px', color: '#1976d2', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
                                        <i className="icon-network" style={{ marginRight: '6px' }}/>
                                        <span style={{ fontWeight: 600 }}>Website</span>
                                    </Box>
                                )}
                            </Box>

                            {/* ⭐ RATINGS ROW */}
                            {eventMeal['location']?.total_ratings > 0 && (
                                <Box sx={{ display: "flex", alignItems: "center", bgcolor: 'rgba(0,0,0,0.03)', p: '6px 12px', borderRadius: '8px', width: 'fit-content', mb: 2 }}>
                                    <Rating name="read-only" value={eventMeal['location'].rating} precision={0.1} readOnly size="small" />
                                    <Typography sx={{ fontSize: '12px', fontWeight: 600, ml: 1, color: 'text.secondary' }}>
                                        ({eventMeal['location'].total_ratings} review{eventMeal['location'].total_ratings === 1 ? '' : 's'})
                                    </Typography>
                                </Box>
                            )}

                            {/* 📝 CONDITIONAL NOTES CONTAINER */}
                            {(
                                eventMeal.notes ||
                                eventMeal.booked_through ||
                                eventMeal.confirmation_number ||
                                eventMeal.reservation_name ||
                                eventMeal.reservation_number ||
                                eventMeal.eatery_notes ||
                                eventMeal.eat_in_details
                            ) && (
                                <Box
                                    sx={{
                                        backgroundColor: 'rgba(255, 255, 255, 0.45)',
                                        border: '1px solid rgba(255,255,255,0.5)',
                                        borderRadius: '12px',
                                        p: 1.5,
                                        mt: 1.5,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 1
                                    }}
                                >
                                    {eventMeal.notes?.length > 0 && (
                                        <Typography variant="caption" sx={{ display: "block" }} color="text.secondary">
                                            <strong style={{ color: '#2c3e50' }}>Notes:</strong> {eventMeal.notes}
                                        </Typography>
                                    )}
                                    {eventMeal.eatery_notes?.length > 0 && (
                                        <Typography variant="caption" sx={{ display: "block" }} color="text.secondary">
                                            <strong style={{ color: '#2c3e50' }}>Eatery Notes:</strong> {eventMeal.eatery_notes}
                                        </Typography>
                                    )}
                                    {eventMeal.booked_through?.length > 0 && (
                                        <Typography variant="caption" sx={{ display: "block" }} color="text.secondary">
                                            <strong style={{ color: '#2c3e50' }}>Booked Through:</strong> {eventMeal.booked_through}
                                        </Typography>
                                    )}
                                    {eventMeal.confirmation_number?.length > 0 && (
                                        <Typography variant="caption" sx={{ display: "block" }} color="text.secondary">
                                            <strong style={{ color: '#2c3e50' }}>Confirmation#:</strong> {eventMeal.confirmation_number}
                                        </Typography>
                                    )}
                                    {eventMeal.reservation_name?.length > 0 && (
                                        <Typography variant="caption" sx={{ display: "block" }} color="text.secondary">
                                            <strong style={{ color: '#2c3e50' }}>Reservation Name:</strong> {eventMeal.reservation_name}
                                        </Typography>
                                    )}
                                    {eventMeal.reservation_number?.length > 0 && (
                                        <Typography variant="caption" sx={{ display: "block" }} color="text.secondary">
                                            <strong style={{ color: '#2c3e50' }}>Reservation#:</strong> {eventMeal.reservation_number}
                                        </Typography>
                                    )}
                                    {eventMeal.eat_in_details?.length > 0 && (
                                        <Box>
                                            <Typography variant="caption" sx={{ fontWeight: 700, color: '#2c3e50', display: 'block' }}>Meal In Details:</Typography>
                                            <Typography variant="caption" color="text.secondary" dangerouslySetInnerHTML={{ __html: eventMeal['eat_in_details'].replace(/\n/g, '<br />') }} />
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </CardContent>

                        {/* 👥 AVATAR ATTENDEE FOOTER TRACKER */}
                        <CardActions sx={{ position: 'absolute', bottom: '8px', right: '12px', p: 0 }}>
                            <AvatarGroup
                                max={10}
                                sx={{
                                    '.MuiAvatar-root': {
                                        zIndex: (theme) => theme.zIndex.drawer + 1,
                                        marginRight: '-6px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                        borderRadius: '50%',
                                        backgroundColor: '#fff',
                                        color: 'text.primary',
                                        fontWeight: '600',
                                        fontSize: '12px',
                                        width: '28px',
                                        height: '28px',
                                    }
                                }}
                            >
                                {eventMeal.attendees
                                    .sort((a, b) => {
                                        const a_attendee = PA_GlobalObject.Planning.attendees.find((_att) => _att.id === a.id);
                                        const b_attendee = PA_GlobalObject.Planning.attendees.find((_att) => _att.id === b.id);
                                        if (!a_attendee && !b_attendee) return 0;
                                        if (!a_attendee) return 1;
                                        if (!b_attendee) return -1;
                                        const aHasNickname = a_attendee.nickname?.trim() || '';
                                        const bHasNickname = b_attendee.nickname?.trim() || '';
                                        return aHasNickname && bHasNickname
                                            ? a_attendee.nickname.toLowerCase().localeCompare(b_attendee.nickname.toLowerCase())
                                            : (a_attendee.fname || '').localeCompare(b_attendee.fname || '');
                                    })
                                    .map((_a) => {
                                        const attendee = PA_GlobalObject.Planning.attendees.find((_att) => _att.id === _a.id);
                                        const attendeeAvatar = attendeesReferenceArray.find((_att) => _att.id === _a.id);
                                        if (!attendee) return null;

                                        const fullName = attendee.nickname?.trim()
                                            ? `${formatName(attendee.nickname)}`
                                            : `${formatName(attendee.fname)} ${formatName(attendee.lname)}`;

                                        const customAvatarStyles = {
                                            border: `1.5px solid ${stringToColor(fullName)}`,
                                        };

                                        return (
                                            <Tooltip key={_a.id} title={fullName} arrow>
                                                {!attendeeAvatar?.avatar || !attendeeAvatar?.avatar.preview ? (
                                                    <Avatar
                                                        {...stringAvatar(`${formatName(attendee.fname)}, ${formatName(attendee.lname)}`)}
                                                        sx={customAvatarStyles}
                                                    />
                                                ) : (
                                                    <Avatar
                                                        src={attendeeAvatar.avatar.preview}
                                                        sx={customAvatarStyles}
                                                    />
                                                )}
                                            </Tooltip>
                                        );
                                    })}
                            </AvatarGroup>
                        </CardActions>
                    </Box>
                </Box>

                {/* Premium Action Menu */}
                <Menu
                    anchorEl={anchorMealListItemMenu}
                    open={Boolean(anchorMealListItemMenu)}
                    onClose={handleMealListItemMenuClose}
                    PaperProps={{ sx: { borderRadius: '14px', width: 240, mt: 1, p: 0.5, boxShadow: '0 10px 25px rgba(0,0,0,0.1)' } }}
                >
                    <Box sx={{ px: 2, py: 1, mb: 0.5 }}>
                        <Typography sx={{ fontSize: '10px', fontWeight: 900, color: '#94a3b8', letterSpacing: 1 }}>SETTINGS</Typography>
                    </Box>
                    {[
                        { key: 'Location', icon: 'icon-map-marker', label: 'Location', color: '#ff6f61' },
                        { key: 'Dates', icon: 'icon-calendar2', label: 'Dates', color: '#d4af37' },
                        { key: 'Costs', icon: 'icon-wallet', label: 'Costs', color: '#2e8b57' },
                        { key: 'Attendees', icon: 'icon-group', label: 'Attendees', color: '#10318f' },
                        { key: 'Details', icon: 'icon-gear', label: 'Details', color: '#6c757d' },
                        { key: 'Photos', icon: 'icon-picture2', label: 'Photos', color: '#8a2be2' },
                    ].map((item) => (
                        <MenuItem key={item.key} onClick={() => handleMenuItemClick(item.label)} sx={{ borderRadius: '8px', mb: 0.2 }}>
                            <ListItemIcon>
                                <Box sx={{ width: 30, height: 30, bgcolor: `${item.color}15`, borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <i className={item.icon} style={{ color: item.color, fontSize: '14px' }} />
                                </Box>
                            </ListItemIcon>
                            <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: '13px', fontWeight: 600 }} />
                        </MenuItem>
                    ))}
                    <Divider sx={{ my: 1 }} />
                    <MenuItem onClick={() => handleMenuItemClick('Delete')} sx={{ borderRadius: '8px', color: '#ef4444' }}>
                        <ListItemIcon>
                            <Box sx={{ width: 30, height: 30, bgcolor: '#fee2e2', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <i className="icon-trash" style={{ color: '#ef4444', fontSize: '14px' }} />
                            </Box>
                        </ListItemIcon>
                        <ListItemText primary="Delete" primaryTypographyProps={{ fontSize: '13px', fontWeight: 600 }} />
                    </MenuItem>
                </Menu>
            </Card>

            <MealDialogEditAttendees
                isOpen={isMealsDialogEditAttendeesOpen}
                onClose={() => setMealsDialogEditAttendeesOpen(false)}
                eventMeal={eventMeal}
                setEventMeal={handleSaveMealUpdate}
            />

            <MealDialogEditCosts
                isOpen={isMealsDialogEditCostsOpen}
                onClose={() => setMealsDialogEditCostsOpen(false)}
                eventMeal={eventMeal}
                setEventMeal={handleSaveMealUpdate}
            />

            <MealDialogEditPhotos
                isOpen={isMealsDialogEditPhotosOpen}
                onClose={() => setMealsDialogEditPhotosOpen(false)}
                eventMeal={eventMeal}
                setEventMeal={handleSaveMealUpdate}
            />

            <MealDialogEditDates
                isOpen={isMealsDialogEditDatesOpen}
                onClose={() => setMealsDialogEditDatesOpen(false)}
                eventMeal={eventMeal}
                setEventMeal={handleSaveMealUpdate}
            />

            <MealDialogEditLocation
                isOpen={isMealsDialogEditLocationOpen}
                onClose={() => setMealsDialogEditLocationOpen(false)}
                eventMeal={eventMeal}
                setEventMeal={handleSaveMealUpdate}
            />

            <MealDialogEditDetails
                isOpen={isMealsDialogEditDetailsOpen}
                onClose={() => setMealsDialogEditDetailsOpen(false)}
                eventMeal={eventMeal}
                setEventMeal={handleSaveMealUpdate}
            />
        </div>
    )
}

export default MealCard;